export default __webpack_public_path__ + "static/media/placeholder_store03-jp-mobile.c654018d.png";